module.exports = __webpack_public_path__ + "sunsemweb/img/sl.fdb0565b.png";